export class AppToken {
  static readonly MENU_SCHEMA_NAME = 'menu';
  static readonly MENU_ITEM_SCHEMA_NAME = 'menu-item';
  static readonly SITE_SETTING_SCHEMA_NAME = 'sitesetting';
  static readonly PAGE_CATEGORY_SCHEMA_NAME = 'pagecategory';
  static readonly PAGE_TYPE_SCHEMA_NAME = 'page-type';
  static readonly PAGE_SCHEMA_NAME = 'page';
  static readonly PAGE_CONTENT_SCHEMA_NAME = 'page-content';
  static readonly SCHEMA_PAGE_SCHEMA_NAME = 'schema-page';
  static readonly PAGE_FILTER_SCHEMA_NAME = 'page-filter';
  static readonly LAYOUT_SCHEMA_NAME = 'layout';
  static readonly RESOURCE_SCHEMA_NAME = 'resource';
  static readonly DEFAULT_LAYOUT_NAME = 'default';
  static readonly TEMPLATE_SCHEMA_NAME = 'template';
  static readonly SECTION_SCHEMA_NAME = 'section';
  static readonly SCRIPT_SCHEMA_NAME = 'html-script';
  static readonly STYLE_SCHEMA_NAME = 'html-style';
  static readonly REDIRECTION_SCHEMA_NAME = 'redirection';
  static readonly USER_SAVE_CULTURE_CODE: string = 'USER_SAVE_CULTURE_CODE';
  static readonly ENGLISH_CULTURE_CODE: string = 'en-CA';
  static readonly FRENCH_CULTURE_CODE: string = 'fr-CA';
  static readonly INPUT_DELAY_TIMESPAN: number = 1000;
  static readonly ISO_DATES_YEAR_MONTH: string = 'yyyy-MM';
  static readonly ISO_DATES_DATE: string = 'yyyy-MM-dd';
  static readonly ISO_DATES_DATE_TIME: string = 'yyyy-MM-dd hh:mm:ss';
  static readonly ISO_DATES_DATE_TIME_UPDATE: string = 'YYYY/MM/DD HH:mm:ss';
  static readonly ISO_DATES_TIME: string = 'hh:mm:ss';
  static readonly PAGES_PUBLISHED_ITEMS_PER_PAGE: number = 12;
  static readonly PAGES_PUBLISHED_CONTENTS_ITEMS_PER_PAGE: number = 12;
  static readonly PAGES_PUBLISHED_ITEMS_PER_PAGE_LIST: number = 10;
  static readonly PAGES_PUBLISHED_CONTENTS_ITEMS_PER_PAGE_LIST: number = 10;
  static readonly PAGES_UNPUBLISHED_ITEMS_PER_PAGE: number = 6;
  static readonly PAGES_UNPUBLISHED_CONTENTS_ITEMS_PER_PAGE: number = 6;
  static readonly ARTICLES_PUBLISHED_ITEMS_PER_PAGE: number = 9;
  static readonly ARTICLES_UNPUBLISHED_ITEMS_PER_PAGE: number = 3;
  static readonly CONTENTS_ITEMS_PER_REQUEST: number = 300;
  static readonly CONTENTS_ITEMS_PER_PAGE: number = 10000;
  static readonly SCHEMA_NAME_MAX_LEGTH: number = 40;
  static readonly ARTICLE_PAGE_SCHEMA_NAME = 'articlepage';
  static readonly APPLICATION_CURRENT_USER = 'current-user';
}

export class AppSchemaCategory {
  static readonly SYSTEM_SCHEMAS = 'System-schemas';
  //static readonly GENERAL_SCHEMAS = 'general-schema';
  static readonly CONTACT_FORMS = 'Contact-forms';
  static readonly DEFAULT_SCHEMAS = 'Default-schemas';
  static readonly CONTENT_SCHEMAS = 'Content-schemas';
  static readonly SCHEMA_AS_A_PAGE = 'Schema-as-a-page';
}

class Status {
  name: string;
  color: string;
}

export class Statuses {
  static readonly PUBLISHED: Status = { name: 'Published', color: '#4bb958' }
  static readonly DRAFT: Status = { name: 'Draft', color: '#8091a5' }
  static readonly ARCHIVED: Status = { name: 'Archived', color: '#eb3142' }
}


export class PreviewDevices {
  static readonly DESKTOP = { name: 'DESKTOP', width: 1080, height: 1920 }
  static readonly TABLET = { name: 'TABLET', width: 960, height: 1024 }
  static readonly PHONE = { name: 'PHONE', width: 640, height: 960 }
}

export class FieldsName {
  static readonly CODE = 'code';
  static readonly ID = 'id';
  static readonly NAME = 'name';
  static readonly INDEX = 'index';
  static readonly PUBLISH_DATE_TIME = 'publishdatetime';
  static readonly DELETE_DATE_TIMEDE = 'deletedatetime';
  static readonly DELETED = 'deleted';
  static readonly PAGE_ID = 'pageid';
  static readonly PAGE = 'page';
  static readonly PAGE_TYPE = 'pageType';
  static readonly MENU_ITEMS = 'menuItems';
  static readonly TEMPLATE = 'template';
  static readonly BODY = 'body';
  static readonly CONTENT_TYPE = 'contenttype';
  static readonly CONTENT_ID = 'contentid';
  static readonly ISMODIFIED = 'ismodified';
  static readonly METATITLE = 'metatitle';
  static readonly TITLE = 'title';
  static readonly DESCRIPTION = 'description';
  static readonly ISSECURE = 'issecure';
  static readonly ISNOINDEX = 'isnoindex';
  static readonly ISACTIVE = 'isactive';
  static readonly PAGE_NAME = 'pageName';
  static readonly LAYOUT = 'layout';
  static readonly URL = 'url';
  static readonly PARENT_ID = 'parentid';
  static readonly META_DESCRIPTION = 'metaDescription';
  static readonly META_KEYWORDS = 'metaKeywords';
  static readonly THUMBNAIL = 'thumbnail';
  static readonly PRIORITY = 'priority';
  static readonly SCHEMA_NAME = 'schemaname';
  static readonly PARENT_MENU_ITEM = 'parentMenuItem'
}

export class DefaultContents {
  static readonly DEFAULT_PAGE_TYPE_CODE = 'default';
  static readonly DEFAULT_MENU_CODE = 'default-menu';
  static readonly DEFAULT_SITE_SETTING_CODE = 'default';
}

export class ClaimTypes {
  static readonly BOOL = 'bool';
  static readonly STRING = 'string';
  static readonly NUMBER = 'number';
}

export class UserRoles {
  static readonly DEVELOPER = 'DEVELOPER';
  static readonly EDITOR = 'EDITOR';
  static readonly OWNER = 'OWNER';
  static readonly READER = 'READER';
  static readonly READWRITE = 'READWRITE';
}
